import React from "react";
import { Link } from "react-router-dom";
import {
  FaFacebookF,
  FaTwitter,
  FaInstagram,
  FaYoutube,
} from "react-icons/fa";

const FooterLink = ({ to, children }) => (
  <li>
    <Link
      to={to}
      className="text-slate-600 hover:text-emerald-700 hover:underline transition"
    >
      {children}
    </Link>
  </li>
);

const SocialIcon = ({ href, icon: Icon }) => (
  <a
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    className="text-slate-500 hover:text-emerald-700 transition-transform duration-300 hover:scale-110"
  >
    <Icon size={22} />
  </a>
);

const Footer = () => {
  return (
    <footer className="bg-gradient-to-r from-amber-200 via-orange-100 to-rose-200 text-slate-800 border-t border-orange-300">
      <div className="max-w-screen-xl mx-auto px-6 py-16">
        {/* Top Section */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Logo & Description */}
          <div className="md:col-span-2 lg:col-span-1 flex flex-col gap-4">
            <Link to="/" className="flex items-start gap-3">
              <img
                src="/images/parasports.png"
                alt="Parasports Logo"
                className="h-16 w-auto object-contain"
              />
              <div className="max-w-xs">
                <p className="font-extrabold text-base leading-tight text-slate-900">
                  Para Sports Association of Andhra Pradesh
                </p>
                <div className="mt-1 flex flex-wrap gap-1.5">
                  <span className="inline-flex items-center rounded-full bg-emerald-100/90 text-[10px] sm:text-[11px] font-semibold text-emerald-900 px-2 py-0.5">
                    Affiliated to Paralympic Committee of India
                  </span>
                  <span className="inline-flex items-center rounded-full bg-amber-100/90 text-[10px] sm:text-[11px] font-semibold text-amber-900 px-2 py-0.5">
                    Recognized by Sports Authority of Andhra Pradesh
                  </span>
                </div>
              </div>
            </Link>
            <p className="text-slate-600 text-sm max-w-xs">
              Empowering Divyang athletes through inclusive training, competitions, and long-term support across Andhra Pradesh.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-bold text-slate-900 mb-4 tracking-wide">
              Quick Links
            </h3>
            <ul className="space-y-3">
              <FooterLink to="/about-us">About Us</FooterLink>
              <FooterLink to="/events">Events</FooterLink>
              <FooterLink to="/gallery">Gallery</FooterLink>
              <FooterLink to="/news">News</FooterLink>
              <FooterLink to="/updates-results">Updates & Results</FooterLink>
            </ul>
          </div>

          {/* Get Involved */}
          <div>
            <h3 className="font-bold text-slate-900 mb-4 tracking-wide">
              Get Involved
            </h3>
            <ul className="space-y-3">
              <FooterLink to="/partner">Partner with Us</FooterLink>
              <FooterLink to="/donate">Donate</FooterLink>
              <FooterLink to="/volunteer">Volunteer</FooterLink>
            </ul>
          </div>

          {/* Contact & Socials */}
          <div>
            <h3 className="font-bold text-slate-900 mb-4 tracking-wide">
              Follow Us
            </h3>
            <div className="flex gap-5 mb-4">
              <SocialIcon href="https://facebook.com/profile.php?id=100066529509916" icon={FaFacebookF} />
              <SocialIcon href="https://www.instagram.com/apparasports?igsh=aG9yazBiMmt5" icon={FaInstagram} />
              <SocialIcon href="https://x.com/paraandhra" icon={FaTwitter} />
              <SocialIcon href="https://youtube.com/@parasportsassociationofand4220?si=1aBpxM8sLIj83hX0" icon={FaYoutube} />
            </div>
            <h3 className="font-bold text-slate-900 mb-4 mt-6 tracking-wide">
              Contact
            </h3>
            <a href="mailto:apparasports@gmail.com" className="text-slate-600 hover:text-emerald-700 transition">Andhra Para Sports (apparasports@gmail.com)</a>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-emerald-200 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-slate-500 text-sm text-center md:text-left">
            © {new Date().getFullYear()} Para Sports Association of Andhra Pradesh. All rights reserved.
          </p>
          <div className="text-slate-500 text-sm flex gap-4">
            <Link to="/privacy-policy" className="hover:text-emerald-700 transition">
              Privacy Policy
            </Link>
            <Link to="/terms" className="hover:text-emerald-700 transition">
              Terms & Conditions
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
